import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .UserHistory {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    gap: 10px;
    @include respond-to(md) {
      row-gap: 45px;
    }
  }

  .UserHistory__login-inner {
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
    padding: rem(25px 30px 25px);
    margin-bottom: rem(20px);
    @include respond-to(sm) {
      padding: rem(20px 15px 15px);
    }
    h2 {
      margin-bottom: rem(25px);
    }
  }

  .UserLoginHistory {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: rem(3px);
    &:last-child {
      margin: 0;
    }
    p {
      font-weight: 500;
      font-size: rem(18px);
      margin-right: rem(20px);
    }
  }
  .UserHistory__month-choose {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: rem(20px);
    .month-picker:first-of-type {
      margin-right: 15px;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .UserHistory__login-inner {
      background: ${colors.white.hex};
    }

    .UserLoginHistory {
      :global(span) {
        color: ${colors.gray.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
